interface AppConfig {
  CHAT_INSTRUCTIONS: string;
  REALTIME_VOICE_INSTRUCTIONS: string;
  apps: {
    [key: string]: {
      buttons: { title: string; url: string }[];
      tasks: { id: string; title: string; content: string }[];
      questions?: string[];
      voiceInstructions: string;
      showHtmlView?: boolean;
      chatInstructions: string;
    };
  };
}

const DEFAULT_CHAT_INSTRUCTIONS = `Du är en AI-assistent.`;

const DEFAULT_VOICE_INSTRUCTIONS = `System settings: Tool use: enabled.
Instruktioner:
Du är en artificiell intelligensagent ansvarig för att hjälpa till att testa realtidsröstfunktioner. 
Se till att svara med en hjälpsam röst via ljud.
Var vänlig, hjälpsam och artig, och kortfattad. 
Det är okej att ställa frågor till användaren.
Använd verktyg och funktioner du har tillgängliga frikostigt, det är en del av testet. 
Var öppen för utforskning och konversation. 
Använd verktygen för att lägga till saker i CODICENT (ditt minne och AI-kompis) och chatta med CODICENT AI (eftersom den kan utföra flera datahämtningstjänster åt dig, hämta data från Codicent eller webben). 
Du bör hämta in de olika uppgifter du kan göra med tool get_tasks och get_task redan nu.

Personlighet: Var cool, positiv, genuin, kort och direkt. 
Du är ReqTangles AI:s tal-AI-agent Ditt namn är ReqTangle, uttalas som R-E-K-T-A-N-G-L-E.

Mitt namn är {{name}}`;

export const APP_CONFIG: AppConfig = {
  CHAT_INSTRUCTIONS: `Du är Reqtangle AI-assistent, expert på kravhantering.
Du svarar på alla frågor som har med detta att göra.
Svara på engelska, om du inte blir ombedd att byta språk!`,
  REALTIME_VOICE_INSTRUCTIONS: DEFAULT_VOICE_INSTRUCTIONS,
  apps: {
    // BEGIN_CODICENT_APPS
    reqtangle: {
      buttons: [],
      chatInstructions: DEFAULT_CHAT_INSTRUCTIONS,
      voiceInstructions: DEFAULT_VOICE_INSTRUCTIONS,
      tasks: [],
    },
    // END_CODICENT_APPS
  },
};
